import { FilterValueType, instanceOfInputValue, instanceOfRangeValue } from 'festo-react-ui-kit';
import { FilterValuesObj } from '../../../features/filter/interfaces';
import { FilterValueKey } from '../../../features/filter/utils';

export const getDisabledFilter = ({ values }: { values: FilterValuesObj }) => {
  const calcResultDict: { [x: string]: string } = {
    P1: FilterValueKey.SUPPLY_PRESSURE,
    P2: FilterValueKey.OUTPUT_PRESSURE,
    QN: FilterValueKey.DISCHARGE,
  };

  const calculationResultValue = values[FilterValueKey.CALCULATION_RESULT].toString();

  return calcResultDict[calculationResultValue];
};

export const getFacetValue = (
  value: FilterValueType | FilterValueType[],
  required?: boolean,
  resetOnEmpty?: boolean,
): FilterValueType | FilterValueType[] => {
  let result = value;

  if (instanceOfRangeValue(result)) {
    result = { ...result, textInput: true };
  } else if (instanceOfInputValue(result)) {
    result = {
      ...result,
      placeholder: !required ? '' : undefined,
      resetOnEmpty: required && resetOnEmpty,
    };
  }

  return result;
};
